import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip';
import { format } from 'date-fns/format';
import { isNil } from 'lodash';
import { TooltipDelays } from '@common/constants/constants';
import NavigationLink from '@common/navigation/navigation-link';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
const contentTypeOption = {
    CREATED: CreatedUserContent,
    UPDATED: UpdatedUserContent,
    ASSIGNED_TO_PROFILE: AssignProfileContent,
    UNASSIGNED_FROM_PROFILE: UnassignProfileContent,
    ADDED_TO_GROUP: AddedToGroupContent,
    REMOVED_FROM_GROUP: RemovedFromGroupContent
};
export function UserAuditLogsContent({ content, type, date }) {
    const Component = contentTypeOption[type];
    const title = `Event time: ${format(date, 'HH:mm')}`;
    return (_jsx(Tooltip, { title: title, delay: TooltipDelays.NORMAL, children: _jsx(Component, { ...content }) }));
}
function AssignProfileContent({ assignedToProfile }) {
    if (!assignedToProfile) {
        return null;
    }
    return (_jsxs(Text, { children: ["Profile", " '", _jsx(NavigationLink, { href: `/profiles/${assignedToProfile.profileId}`, children: assignedToProfile.profileTitle }), "' ", "assigned to the user"] }));
}
function UnassignProfileContent({ unassignedFromProfile }) {
    if (!unassignedFromProfile) {
        return null;
    }
    return (_jsxs(Text, { children: ["Profile", " '", _jsx(NavigationLink, { href: `/profiles/${unassignedFromProfile.profileId}`, children: unassignedFromProfile.profileTitle }), "' ", "unassigned from the user"] }));
}
function AddedToGroupContent({ addedToGroup }) {
    const serverConfig = useServerConfigContext();
    const idpImportEnabled = serverConfig.hasIdpIntegration();
    if (!addedToGroup || !idpImportEnabled) {
        return null;
    }
    return (_jsxs(Text, { children: ["User added to the group", " '", _jsx(NavigationLink, { href: `/groups/${addedToGroup.groupId}`, children: addedToGroup.groupName }), "' "] }));
}
function RemovedFromGroupContent({ removedFromGroup }) {
    const serverConfig = useServerConfigContext();
    const idpImportEnabled = serverConfig.hasIdpIntegration();
    if (!removedFromGroup || !idpImportEnabled) {
        return null;
    }
    return (_jsxs(Text, { children: ["User removed from the group", " '", _jsx(NavigationLink, { href: `/profiles/${removedFromGroup.groupId}`, children: removedFromGroup.groupName }), "' "] }));
}
function CreatedUserContent() {
    return _jsx(Text, { children: "User created" });
}
function UpdatedUserContent({ updated }) {
    if (!updated) {
        return null;
    }
    const { username } = updated.newUser;
    if (isNil(updated.prevUser) && !isNil(username)) {
        return _jsxs(Text, { children: ["Updated user ", username] });
    }
    return (_jsx(_Fragment, { children: Object.keys(updated.newUser).map(key => {
            var _a;
            const newProp = updated.newUser[key];
            const oldProp = (_a = updated.prevUser) === null || _a === void 0 ? void 0 : _a[key];
            if (newProp !== oldProp) {
                if (key === 'isActive') {
                    return _jsxs("div", { children: ["User ", updated.newUser.isActive ? 'activated' : 'deactivated'] });
                }
                if (!oldProp) {
                    return (_jsxs("div", { children: ["Set ", _jsx("strong", { children: key }), " to ", newProp] }));
                }
                return (_jsxs("div", { children: ["Changed ", _jsx("strong", { children: key }), " from ", oldProp, " to ", newProp] }));
            }
            return '';
        }) }));
}
